import { BaseRouteService } from 'core/services';

class NikoPatientDetailRouteService extends BaseRouteService {
    constructor() {
        super('niko-patient-details');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityId,includeInactive,facilityOrderId,nikoPatientId,isCopy,excludeMasterPatients,hasTemplateInFacilityOrder}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    updatePatientInformation(resource) {
        return super.update(this.base + '/update-patient-information/{id}', resource);
    }

    updatePatientStatus(resource) {
        return super.update(this.base + '/update-patient-status/{id}', resource);
    }

    updatePatientFacility(resource) {
        return super.update(this.base + '/update-patient-facility/{id}', resource);
    }

    updatePatientInsuranceInfo(resource) {
        return super.update(this.base + '/update-patient-insurance-info/{id}', resource);
    }

    downloadReport(resource) {
        return super.find(this.base + '/template-report/{?facilityId,patientId,corporateId,includeAll,includeHospital}', resource);
    }

    downloadPsoReport(resource) {
        return super.find(this.base + '/pso-report/{?facilityId,patientId,itemCategoryId,billingValidation,dosDateFrom,dosDateTo}', resource);
    }

    updateNikoPatientReasonForChange(resource) {
        return super.update(this.base + '/update-patient-reason-for-change/{id}', resource);
    }

    precheckNikoPatientReasonForChange(resource) {
        return super.create(this.base + '/update-patient-reason-for-change-precheck/{id}', resource);
    }

    deleteNikoPatientDetailInsurance(resource) {
        return super.delete(this.base + '/patient-insurance/{id}', resource);
    }

    updateNikoPatientDetailInsurance(resource) {
        return super.update(this.base + '/patient-insurance/{id}', resource);
    }

    createNikoPatientDetailInsurance(resource) {
        return super.create(this.base + '/patient-insurance', resource);
    }

    getEligibilityStatusNote(resource) {
        return super.create(this.base + '/eligibility-status-note', resource);
    }
}

export default NikoPatientDetailRouteService;